var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnticsWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1881 4H5.81298C4.23722 4 3 5.23711 3 6.8128C3 8.38741 4.23719 9.62453 5.8119 9.62453C6.03656 9.62453 6.14941 9.62452 6.37406 9.51167L6.37502 19.0001C6.37507 19.5523 6.82277 20 7.37502 20H7.62486C8.17714 20 8.62486 19.5523 8.62486 19V8.50028H10.8746V19C10.8746 19.5523 11.3223 20 11.8746 20H12.1244C12.6767 20 13.1244 19.5523 13.1244 19.0001L13.1254 8.50028H15.3751V19C15.3751 19.5523 15.8228 20 16.3751 20H16.6249C17.1771 20 17.6249 19.5523 17.6249 19V9.51276C17.8495 9.51276 17.9624 9.6256 18.187 9.6256C19.7617 9.6256 21 8.38849 21 6.8128C21 5.23714 19.7629 4 18.1881 4Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnticsWhite);
export default __webpack_public_path__ + "static/media/antics-white.d34add3f339d319a3acb170d396c8933.svg";
export { ForwardRef as ReactComponent };